<script setup lang="ts">
import {getCurrentInstance} from "vue";

const instance = getCurrentInstance();
const props = defineProps({
  align: {
    type: String,
    default() {
      return 'center'
    }
  },
  text: String,
  color: {
    type: String,
    default() {
      return 'text'
    }
  },
  small: {
    type: Boolean,
    default() {
      return false
    }
  }
});
const styles = computed(() => {
  return {

  }
});
</script>

<template>
  <div class="a-blurb main-writing" :style="styles" :class="'text-'+align+ ' text-'+color">
    <slot>
      {{ text }}
    </slot>
  </div>
</template>

<style lang="scss">

</style>
